import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ProductShare = lazy(() => import(/* webpackChunkName: "ProductShare" */ './components/ProductShare'));

const productShareNodes = Array.from(document.querySelectorAll('[data-product-share]'));

// Check nodes
if (productShareNodes) {
    productShareNodes.forEach((node) => {
        // Parse props
        const props = parseDatasetToProps(node.dataset);

        // Render component
        render(
            <Suspense fallback={<></>}>
                <ProductShare
                    {...props}
                    showText={node.hasAttribute("data-show-text")}
                />
            </Suspense>,
            node
        );
    });
}
